import { AsyncSubject, Observable } from 'rxjs';
import httpService from './httpService';
import mockData from './mock.json';

const mockingTables: string[] = [
  // if we need to mock a lookup, put the name here and then put the mocked rows in mock.json
];

class LookupService {
  private readonly apiBaseF1;
  private readonly apiBaseAccounting;

  constructor() {
    const { __environment__ } = window as any;
    this.apiBaseF1 = __environment__.REACT_APP_LOOKUP_API_F1_URL.trim();
    this.apiBaseAccounting =
      __environment__.REACT_APP_ACCOUNTING_API_URL.trim();
  }

  public getLookupItems(tableName: string): Observable<any[]> {
    if (mockingTables.includes(tableName)) {
      return this.getMockItems(tableName);
    }
    return httpService.getJSON(
      `${this.apiBaseF1}/${tableName}?includeInactive=true`,
    );
  }

  public createLookupItem(tableName: string, item: any): Observable<any> {
    if (mockingTables.includes(tableName)) {
      return this.createMockItem(tableName, item);
    }

    return httpService.postJSON(`${this.apiBaseF1}/${tableName}`, item);
  }

  public updateLookupItem(tableName: string, item: any): Observable<any> {
    if (mockingTables.includes(tableName)) {
      return this.updateItem(item);
    }

    if (tableName === 'stateCodeList') {
      return httpService.patchJSON(
        `${this.apiBaseAccounting}/${tableName}/${item.stateCode}`,
        item,
      );
    }

    const idName = `${tableName}ID`;
    const id = item[idName];
    return httpService.patchJSON(`${this.apiBaseF1}/${tableName}/${id}`, item);
  }

  private getMockItems(tableName: string): Observable<any[]> {
    const subject = new AsyncSubject<any[]>();
    subject.next(mockData[tableName as keyof typeof mockData]);
    subject.complete();
    return subject;
  }

  private createMockItem(tableName: string, item: any): Observable<any> {
    const subject = new AsyncSubject<any>();
    subject.next({
      ...item,
      [`${tableName}ID`]: Math.round(Math.random() * 100000),
    });
    subject.complete();
    return subject;
  }

  private updateItem(item: any): Observable<any> {
    const subject = new AsyncSubject<any>();
    subject.next({
      ...item,
    });
    subject.complete();
    return subject;
  }

  public getLookupsApiInfo(): Observable<string> {
    const apiUrl = this.apiBaseF1.split('transport')?.[0];
    const url = `${apiUrl}/health-check`;
    return httpService.getJSON(url);
  }
}

const lookupService = new LookupService();

export default lookupService;
